var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0 title grey--text text--lighten-2"},[_c('span',{staticClass:"our-chart-is-empty-placeholder-text"},[_vm._v("No data to display")])])
}]

export { render, staticRenderFns }